import { VideoConstants } from '../_constants';

export function video(state = {}, action) {
  switch (action.type) {
    case VideoConstants.GET_VIDEO_BYTOPICID_REQUEST:
      return {
        loading: true
      };
    case VideoConstants.GET_VIDEO_BYTOPICID_SUCCESS:
      return {
        videos: action.videos
      };
    case VideoConstants.GET_VIDEO_BYTOPICID_FAILURE:
      return { 
        error: action.error
      };

      case VideoConstants.GET_VIDEO_BYSUBTOPICID_REQUEST:
      return {
        loading: true
      };
    case VideoConstants.GET_VIDEO_BYSUBTOPICID_SUCCESS:
      return {
        videos: action.videos
      };
    case VideoConstants.GET_VIDEO_BYSUBTOPICID_FAILURE:
      return { 
        error: action.error
      };

      case VideoConstants.GET_PLAYLIST_VIDEO_REQUEST:
      return {
        loading: true
      };
    case VideoConstants.GET_PLAYLIST_VIDEO_SUCCESS:
      return {
        videos: action.videos
      };
    case VideoConstants.GET_PLAYLIST_VIDEO_FAILURE:
      return { 
        error: action.error
      };

      case VideoConstants.GET_FAVORITE_VIDEO_REQUEST:
      return {
        loading: true
      };
    case VideoConstants.GET_FAVORITE_VIDEO_SUCCESS:
      return {
        videos: action.videos
      };
    case VideoConstants.GET_FAVORITE_VIDEO_FAILURE:
      return { 
        error: action.error
      };

      case VideoConstants.GET_UNALLOCATED_VIDEO_REQUEST:
      return {
        loading: true
      };
    case VideoConstants.GET_UNALLOCATED_VIDEO_SUCCESS:
      return {
        videos: action.videos
      };
    case VideoConstants.GET_UNALLOCATED_VIDEO_FAILURE:
      return { 
        error: action.error
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/video.reducer.js